module.exports = __webpack_public_path__ + "static/media/tooltip-icon.2310d8eb.svg";